import React, { Suspense } from "react";
import Cards from "./Cards";

const HomeSuggestion = () => {
  const projects = [
    {
      title: "WCR_Inspect",
      description: "Inspection & monitoring system for railway operations.",
      text: "Inspection & monitoring system for railway operations.",
    },
    {
      title: "Rail-Pariksha",
      description: "Online examination and railway preparation platform.",
      text: "Online examination and railway preparation platform.",
    },
  ];

  return (
    <section className="p-3 p-md-4">
      <div className="">
        {/* Header */}
        <div className="row align-items-center mb-4">
          <div className="col">
            <span className="badge bg-dark mb-2">EXPLORE</span>

            <h2 className="fw-bold mb-2">Other Projects</h2>

            <p className="text-secondary mb-0">
              Explore some of our other railway digital initiatives.
            </p>
          </div>

          <div className="col-auto text-center">
            <div className="display-6 fw-bold">{projects.length}</div>

            <small className="text-uppercase text-secondary">Projects</small>
          </div>
        </div>
        <hr />
        {/* Projects */}
        <div className="row g-3 justify-content-center">
          {projects.map((project, index) => (
            <div className="col col-sm col-md col-lg" key={index}>
              <div className="h-100 ">
                <div
                  className="p-3"
                  style={{
                    background: "rgba(0,0,0,0)",
                  }}
                >
                  <Suspense
                    fallback={
                      <div className="text-center py-4">
                        <div className="spinner-border spinner-border-sm" />
                        <span className="ms-2 text-muted">Loading...</span>
                      </div>
                    }
                  >
                    <Cards title={project.title} TextData={project.text} />
                  </Suspense>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeSuggestion;
